import { TimeUnit } from "@archetypes/form";
import { format } from "date-fns";

export function DATEDIF(date1: Date, date2: Date, format: TimeUnit): number {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  if (isNaN(d1.getTime()) || isNaN(d2.getTime())) {
    throw new Error("Invalid date");
  }
  const MS_IN_SECOND = 1000;
  const MS_IN_MINUTE = MS_IN_SECOND * 60;
  const MS_IN_HOUR = MS_IN_MINUTE * 60;
  const MS_IN_DAY = MS_IN_HOUR * 24;
  const MS_IN_WEEK = MS_IN_DAY * 7;

  const diffMilliseconds = d2.getTime() - d1.getTime();
  const updatedFormat = format?.toString().toLowerCase();
  switch (updatedFormat) {
    case TimeUnit.Seconds:
      return Math.floor(diffMilliseconds / MS_IN_SECOND);

    case TimeUnit.Minutes:
      return Math.floor(diffMilliseconds / MS_IN_MINUTE);

    case TimeUnit.Hours:
      return Math.floor(diffMilliseconds / MS_IN_HOUR);

    case TimeUnit.Days:
      return Math.floor(diffMilliseconds / MS_IN_DAY);

    case TimeUnit.Week:
      return Math.floor(diffMilliseconds / MS_IN_WEEK);

    case TimeUnit.Months: {
      const yearDiff = d2.getFullYear() - d1.getFullYear();
      const monthDiff = d2.getMonth() - d1.getMonth();
      return yearDiff * 12 + monthDiff;
    }

    case TimeUnit.Year:
      return d2.getFullYear() - d1.getFullYear();

    default:
      throw new Error(`Invalid format: ${format}`);
  }
}

export function PERCENT(percentage: number, baseValue: number): number {
  return (percentage / 100) * baseValue;
}

export function DATEFORMAT(date: string, dateFormat: string): string | number {
  const dt = new Date(date);
  if (isNaN(dt.getTime())) {
    throw new Error("Invalid date");
  }
  return format(dt, dateFormat);
}
